// removed by extract-text-webpack-plugin
module.exports = {"activeBetsResume":"_2vOvkLdeK1pV_bHjb0Al6D","title":"_1IMnlCbeNfEykJuWMlbTGK","dateLocation":"_2Q3pc8eecpCbmr4D4qHEpI","stake":"_2lHMzrnPZcY_FHP-hOcL2v","marketName":"_2299nSaznUfU7tgow0fabg","assets":"OB0KD2ALWB3Rd-5eWay7r","potentialReturns":"_1UTq3fLZtsunjUq9sR0Sc-","betHistoryRowEven":"_37YzjfgYs-8gyUUKGIKDUB","betHistoryRowOdd":"_2fAlkL8VcXa3A_tKXcPUBP","innerAssetsContent":"_5onzd1gZGJrXoHQUDiIYo","marketRacerIconContainer":"_1tXBys2Jzl_eV6n5NlO_lP","racerNumber":"_1TqtA8Hy-4jr307-Q3yOnb","marketRacerIcon":"_2s4DVnYNQydOQiQOq-dTJC"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/sharedComponents/css/activeBetsResume.css
// module id = 1009
// module chunks = 0